import * as React from "react";
import DebouncedInput from "../../helper/DebouncedInput";
import {
  RankingInfo,
  rankItem,
  compareItems,
} from "@tanstack/match-sorter-utils";
import { downloadIcon, history, rectangle } from "../../../assetData/icons";

import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  // getFacetedRowModel,
  // getFacetedUniqueValues,
  // getFacetedMinMaxValues,
  // sortingFns,
  getSortedRowModel,
  flexRender,
  sortingFns,
} from "@tanstack/react-table";

import TablePageIndicator from "../../master/TablePageIndicator";
import CustomTablePagination from "../../master/TablePagination";
import ComponentLoader from "../../ui/pageLoader/ComponentLoader";
import EligibleHolding from "../eligibleHolding/EligibleHoldingHeader";

import {
  searchIcon,
  editPencilIcon,
  deleteIconDark,
} from "../../../assetData/icons";
import { useState } from "react";
import { format } from "date-fns";
import CellDropDown from "./dropDowns/CellDropDown";
import { MdFilterAlt, MdOutlineFilterAlt } from "react-icons/md";

const fuzzyFilter = (row, columnId, value, addMeta) => {
  const itemRank = rankItem(row.getValue(columnId), value);

  addMeta({
    itemRank,
  });

  return itemRank.passed;
};

const fuzzySort = (rowA, rowB, columnId) => {
  let dir = 0;

  // Only sort by rank if the column has ranking information
  if (
    rowA.columnFiltersMeta &&
    rowA.columnFiltersMeta[columnId] &&
    rowB.columnFiltersMeta &&
    rowB.columnFiltersMeta[columnId]
  ) {
    dir = compareItems(
      rowA.columnFiltersMeta[columnId].itemRank,
      rowB.columnFiltersMeta[columnId].itemRank,
    );
  }
  return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir;
};

function CorporateMasterTable(props) {
  const {
    tableData,
    columns,
    setIsEdit,
    setSelectedItemId,
    renderKey,
    filterField,
    actionConfig = [],
    buttonConfig,
    isLoading,
    setGlobalFilters,
    rowId,
    isDropDownVisible,
    setRowData,
    setRejectedId,
    setRowIdAndHideShow,
    setIsFilter,
    isFilter,
  } = props;

  const [data, setData] = React.useState([]);
  const [columnFilters, setColumnFilters] = React.useState([]);
  const [globalFilter, setGlobalFilter] = React.useState("");

  const [ids, setIds] = useState("");
  const [isHover, setIsHover] = useState(false);

  const [scripRowId, setScripRowId] = useState("");
  const [scripRowHover, setScripRowHover] = useState(false);
  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const savedPage = sessionStorage.getItem("CorporateActionMaster");
  const pageIndex = savedPage ? parseInt(savedPage, 10) - 1 : 0;
  const hoverEffect = (info) => {
    setIsHover(true);
    setIds(info);
  };

  const removeHover = () => {
    setIsHover(false);
    setIds("");
  };

  const hoverScriptEffect = (info) => {
    setScripRowHover(true);
    setScripRowId(info);
  };

  const removeScriptHover = () => {
    setScripRowHover(false);
    setScripRowId("");
  };

  const customTable = useReactTable({
    data,
    columns,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    state: {
      columnFilters,
      globalFilter,
      pagination,
    },
    initialState: {
      pagination: { pageIndex: pageIndex },
    },
    onPaginationChange: setPagination,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: fuzzyFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  const pageName = "CorporateActionMaster";

  React.useEffect(() => {
    const interval = setInterval(() => {
      if (pageIndex === 0) {
        customTable.setPageIndex(0);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [pageIndex, customTable]);

  React.useEffect(() => {
    if (customTable.getState().columnFilters[0]?.id === "fullName") {
      if (customTable.getState().sorting[0]?.id !== "fullName") {
        customTable.setSorting([{ id: "fullName", desc: false }]);
      }
    }
  }, [customTable.getState().columnFilters[0]?.id]);

  React.useEffect(() => {
    if (tableData) setData(tableData);
  }, [tableData]);

  if (!data) return null;

  return (
    <div>
      <div className="items-center justify-between md:flex">
        {/* <EligibleHolding /> */}
        <TablePageIndicator
          className={"max-lg:hidden"}
          currentNumber={customTable.getFilteredRowModel().rows?.length}
          totalNumber={data?.length}
        />
        {/* Actions */}
        <div className="mb-4 w-[100%] items-center justify-between gap-4 lg:flex">
          {filterField && (
            <>
              <div className="flex items-center gap-2 border-b-[1px] border-[#636363] max-lg:mb-6 max-lg:w-[420px] max-sm:w-[100%] lg:ml-[40px] ">
                <img src={searchIcon} alt="" />
                <DebouncedInput
                  value={globalFilter ?? ""}
                  onChange={(value) => setGlobalFilters(String(value))}
                  className=" bg-transparent  py-1 text-[14px] text-neutral-800 focus:outline-none"
                  placeholder="Search"
                />
              </div>
            </>
          )}

          <div className="flex items-center gap-4 max-md:flex-wrap ">
            <div className="flex w-[168px] items-baseline justify-center rounded-md border-[1px] border-[#868686] bg-white px-1 py-1 shadow-lg max-[425px]:w-[136px] max-[355px]:w-[118px] sm:hidden">
              <div
                onClick={() => setIsFilter(true)}
                className="flex items-center space-x-4 text-[17px] font-bold text-neutral-800 opacity-70"
              >
                {isFilter ? (
                  <MdFilterAlt className={`text-[17px] `} />
                ) : (
                  <MdOutlineFilterAlt className={`text-[17px]  `} />
                )}
                Filter
              </div>
            </div>
            {/* {actionConfig
              .map((action, idx) => (
                <div key={action.id} className="flex items-center gap-4">
                  {idx !== 0 && (
                    <div className="h-[35px] w-[2px] bg-neutral-200 max-md:hidden" />
                  )}
                  <button
                    className={`flex items-center gap-2 rounded border-[1px] border-[#636363] px-6 py-1 font-bold text-[#636363] max-[425px]:px-2 max-[355px]:px-1 ${
                      action.disable ? "" : "opacity-[55%]"
                    }`}
                    onClick={action.actionHandler}
                    disabled={!action.disable}
                  >
                    <img src={action.image} alt="i4Invest" />
                    {action.name}
                  </button>
                </div>
              ))} */}
            {actionConfig
              // .filter((item) => item.name !== "Add Corp. Action")
              .map((action, idx) => (
                <div key={action.id} className="flex items-center gap-4">
                  {idx !== 0 && (
                    <div className="h-[35px] w-[2px] bg-neutral-200" />
                  )}
                  <button
                    className={`flex items-center gap-2 rounded border-[1px] border-[#636363] px-6 py-1 font-bold text-[#636363] max-[425px]:px-2 max-[355px]:px-1 ${
                      action.disable ? "" : "opacity-[55%]"
                    }`}
                    onClick={action.actionHandler}
                    disabled={!action.disable}
                  >
                    <img src={action.image} alt="i4Invest" />
                    {action.name}
                  </button>
                </div>
              ))}
          </div>
        </div>
      </div>
      <TablePageIndicator
        className={"lg:hidden"}
        currentNumber={customTable.getFilteredRowModel().rows?.length}
        totalNumber={data?.length}
      />
      <div className="mb-4 flex w-full items-center gap-2 space-x-2 md:justify-end">
        <div className="flex w-fit items-center gap-2 space-x-2">
          <label className="text-[#868686]">Show Rows: </label>
          <select
            className="text-dropdown-text w-[100px] bg-gray-100 py-[0.4rem] text-[15px] text-[#868686] focus:outline-none"
            onChange={(e) => {
              const value =
                e.target.value === "All" ? data.length : Number(e.target.value);
              setPagination((old) => ({
                ...old,
                pageSize: value,
              }));
            }}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="All">All</option>
          </select>
        </div>
      </div>
      <div className=" scrollbar-custom overflow-y-hidden max-xl:overflow-x-scroll ">
        <table className="w-full ">
          <thead className="bg-pri-clr-blue">
            {customTable.getHeaderGroups().map((headerGroup, i) => (
              <tr key={i}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="border-1 border-black px-2 py-2 text-start text-[12px] font-bold uppercase text-white"
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <thead className="h-2">
            <tr></tr>
          </thead>

          {data === null && <h1 className="text-black">No Data</h1>}
          {isLoading && <ComponentLoader />}

          {isLoading === false && (
            <tbody className="border-[1px] border-neutral-clr-300 pt-2">
              {customTable.getRowModel().rows.map((row) => (
                <tr
                  key={row.id}
                  className={
                    rowId?.id === row.id && isDropDownVisible ? "" : ""
                  }
                >
                  {row.getVisibleCells().map((cell) => (
                    <td
                      key={cell.id}
                      className="w-fit overflow-hidden border-[1px] border-neutral-clr-300 px-1 text-[14px] text-black"
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                      {cell.id.split("_")[1] === "inputile" && (
                        <>
                          <div
                            className="flex h-[26px] cursor-pointer items-center justify-start px-[2px]"
                            onMouseOver={() => hoverEffect(row?.id)}
                            onMouseLeave={() => removeHover()}
                          >
                            {row?.original.inputile_id}
                          </div>
                          {isHover && ids === row.id ? (
                            <div className="absolute z-[1000] mt-[2px] w-[300px] rounded bg-[#D9D9D9] p-[4px] text-[#636363]">
                              {row?.original?.remarks}
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      )}

                      {cell.id.split("_")[1] === "company" &&
                        cell.id.split("_")[2] === "name" && (
                          <>
                            <span
                              className=" mt-[-26px] flex h-[26px] w-[150px] cursor-pointer items-center justify-start whitespace-nowrap px-[2px]"
                              onMouseOver={() => hoverScriptEffect(row?.id)}
                              onMouseLeave={() => removeScriptHover()}
                            >
                              {row?.original.company_name &&
                              row?.original.company_name !== "nan"
                                ? row?.original.company_name?.length > 20
                                  ? row?.original.company_name.substring(
                                      0,
                                      20,
                                    ) + "..."
                                  : row?.original.company_name
                                : ""}
                            </span>
                            {scripRowHover &&
                            scripRowId === row.id &&
                            row?.original.company_name?.length > 20 ? (
                              <div className="absolute z-[1000] mt-[1px] w-[300px] rounded bg-[#D9D9D9] p-[4px] text-[#636363]">
                                {row?.original?.company_name}
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        )}

                      {cell.id.split("_")[1] === "i" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"i"}
                          isDropDownVisible={isDropDownVisible}
                          setRejectedId={setRejectedId}
                          buttonConfig={buttonConfig}
                          setRowIdAndHideShow={setRowIdAndHideShow}
                        />
                      )}
                      {cell.id.split("_")[1] === "inputile" &&
                        cell.id.split("_")[2] === "id" && (
                          <CellDropDown
                            cell={cell}
                            rowId={rowId}
                            valueToGet={"inputile_id"}
                            isDropDownVisible={isDropDownVisible}
                            setRejectedId={setRejectedId}
                            buttonConfig={buttonConfig}
                            setRowIdAndHideShow={setRowIdAndHideShow}
                          />
                        )}
                      {cell.id.split("_")[1] === "script" &&
                        cell.id.split("_")[2] === "name" && (
                          <CellDropDown
                            cell={cell}
                            rowId={rowId}
                            valueToGet={"script_name"}
                            isDropDownVisible={isDropDownVisible}
                            setRejectedId={setRejectedId}
                            buttonConfig={buttonConfig}
                            setRowIdAndHideShow={setRowIdAndHideShow}
                          />
                        )}
                      {cell.id.split("_")[1] === "face" &&
                        cell.id.split("_")[2] === "value" && (
                          <CellDropDown
                            cell={cell}
                            rowId={rowId}
                            valueToGet={"face_value"}
                            isDropDownVisible={isDropDownVisible}
                            setRejectedId={setRejectedId}
                            buttonConfig={buttonConfig}
                            setRowIdAndHideShow={setRowIdAndHideShow}
                          />
                        )}
                      {cell.id.split("_")[1] === "corpaction" &&
                        cell.id.split("_")[2] === "tag" && (
                          <CellDropDown
                            cell={cell}
                            rowId={rowId}
                            valueToGet={"corpaction_tag"}
                            isDropDownVisible={isDropDownVisible}
                            setRejectedId={setRejectedId}
                            buttonConfig={buttonConfig}
                            setRowIdAndHideShow={setRowIdAndHideShow}
                          />
                        )}
                      {cell.id.split("_")[1] === "bookclose" &&
                        cell.id.split("_")[2] === "recorddate" && (
                          <CellDropDown
                            cell={cell}
                            rowId={rowId}
                            valueToGet={"bookclose_recorddate"}
                            isDropDownVisible={isDropDownVisible}
                            setRejectedId={setRejectedId}
                            buttonConfig={buttonConfig}
                            setRowIdAndHideShow={setRowIdAndHideShow}
                          />
                        )}
                      {cell.id.split("_")[1] === "nse" &&
                        cell.id.split("_")[2] === "exdate" && (
                          <CellDropDown
                            cell={cell}
                            rowId={rowId}
                            valueToGet={"nse_exdate"}
                            isDropDownVisible={isDropDownVisible}
                            setRejectedId={setRejectedId}
                            buttonConfig={buttonConfig}
                            setRowIdAndHideShow={setRowIdAndHideShow}
                          />
                        )}
                      {cell.id.split("_")[1] === "bse" &&
                        cell.id.split("_")[2] === "exdate" && (
                          <CellDropDown
                            cell={cell}
                            rowId={rowId}
                            valueToGet={"bse_exdate"}
                            isDropDownVisible={isDropDownVisible}
                            setRejectedId={setRejectedId}
                            buttonConfig={buttonConfig}
                            setRowIdAndHideShow={setRowIdAndHideShow}
                          />
                        )}
                      {cell.id.split("_")[1] === "price" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"price"}
                          isDropDownVisible={isDropDownVisible}
                          setRejectedId={setRejectedId}
                          buttonConfig={buttonConfig}
                          setRowIdAndHideShow={setRowIdAndHideShow}
                        />
                      )}
                      {cell.id.split("_")[1] === "multiplier" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"multiplier"}
                          isDropDownVisible={isDropDownVisible}
                          setRejectedId={setRejectedId}
                          buttonConfig={buttonConfig}
                          setRowIdAndHideShow={setRowIdAndHideShow}
                        />
                      )}
                      {cell.id.split("_")[1] === "company" &&
                        cell.id.split("_")[2] === "name" && (
                          <CellDropDown
                            cell={cell}
                            rowId={rowId}
                            valueToGet={"company_name"}
                            isDropDownVisible={isDropDownVisible}
                            setRejectedId={setRejectedId}
                            buttonConfig={buttonConfig}
                            setRowIdAndHideShow={setRowIdAndHideShow}
                          />
                        )}

                      {cell.id.split("_")[1] === "caa" &&
                        cell.id.split("_")[2] === "status" && (
                          <CellDropDown
                            cell={cell}
                            rowId={rowId}
                            valueToGet={"caa_status"}
                            setRowData={setRowData}
                            setIsEdit={setIsEdit}
                            isDropDownVisible={isDropDownVisible}
                            setRejectedId={setRejectedId}
                            buttonConfig={buttonConfig}
                            setRowIdAndHideShow={setRowIdAndHideShow}
                            setSelectedItemId={setSelectedItemId}
                          />
                        )}

                      {cell.id.split("_")[1] === "addl" &&
                        cell.id.split("_")[2] === "status" && (
                          <CellDropDown
                            cell={cell}
                            rowId={rowId}
                            valueToGet={"addl_status"}
                            setRowData={setRowData}
                            setIsEdit={setIsEdit}
                            isDropDownVisible={isDropDownVisible}
                            setRejectedId={setRejectedId}
                            buttonConfig={buttonConfig}
                            setRowIdAndHideShow={setRowIdAndHideShow}
                            setSelectedItemId={setSelectedItemId}
                          />
                        )}
                      {cell.id.split("_")[1] === "status" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"status"}
                          isDropDownVisible={isDropDownVisible}
                          setRejectedId={setRejectedId}
                          buttonConfig={buttonConfig}
                          setRowIdAndHideShow={setRowIdAndHideShow}
                        />
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
      {data && (
        <CustomTablePagination
          table={customTable}
          renderKey={renderKey}
          pageName={pageName}
        />
      )}
    </div>
  );
}

export default CorporateMasterTable;
